import React from 'react';
import styled from 'styled-components';
import { darken } from 'polished';
//
import colors from 'theme/colors';
import { Tooltip } from '@material-ui/core';

const { darkInputBorder, darkPanelBackground } = colors;

export interface IAcronymCircleProps {
  backgroundColor?: string;
  color?: string;
  fontSize?: number;
  onClick: () => void;
  size?: number;
  title: string;
  tooltipTitle?: string;
  disableHoverEffects?: boolean;
}

const colorGradient = 0.2;

const Container = styled.button<{ backgroundColor: string; disableHoverEffects: boolean; size: number }>`
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border: none;
  border-radius: ${props => props.size}px;
  display: flex;
  height: ${props => props.size}px;
  justify-content: center;
  transition: background-color 0.1s ease;
  width: ${props => props.size}px;

  :active,
  :focus {
    outline: none;
  }

  :hover {
    background-color: ${props =>
      props.disableHoverEffects ? props.backgroundColor : darken(colorGradient, props.backgroundColor)};
    cursor: ${props => (props.disableHoverEffects ? 'arrow' : 'pointer')};
  }
`;

const Letters = styled.div<{ color: string; fontSize: number }>`
  color: ${props => props.color};
  font-size: ${props => props.fontSize}px;
  font-weight: 600;
`;

const cirlceSize = 32;
const circleFontSize = 14;

export default ({
  backgroundColor = darkInputBorder,
  color = darkPanelBackground,
  size = cirlceSize,
  fontSize = circleFontSize,
  onClick,
  title,
  tooltipTitle = 'Deal Analyzer',
  disableHoverEffects = false,
}: IAcronymCircleProps) => {
  return (
    <Container
      backgroundColor={backgroundColor}
      size={size}
      onClick={onClick}
      disableHoverEffects={disableHoverEffects}
    >
      <Tooltip title={tooltipTitle}>
        <Letters color={color} fontSize={fontSize}>
          {title}
        </Letters>
      </Tooltip>
    </Container>
  );
};
